import styled from 'styled-components';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { PriceText } from 'src/components/offer/price/price-text';
import { layout } from 'src/components/base';

export const StyledPrice = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${layout.measurements.spacing050};
  white-space: nowrap;
`;

export const StyledSecondaryPrice = styled(PriceText)`
  text-decoration: line-through;
`;

export const StyledIconTooltip = styled(Tooltip)`
  display: flex;
  align-self: center;
`;

export const StyledSecondaryPriceWrapper = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing025};
`;
